// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file core/v1/facility.proto (package core.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { Address, Base, ID, Timezone } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file core/v1/facility.proto.
 */
export const file_core_v1_facility: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_struct, file_types]);

/**
 * Facility represents a physical location or establishment
 *
 * @generated from message core.v1.Facility
 */
export type Facility = Message<"core.v1.Facility"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string facility_name = 2;
   */
  facilityName: string;

  /**
   * @generated from field: string facility_type = 3;
   */
  facilityType: string;

  /**
   * @generated from field: types.Timezone timezone = 4;
   */
  timezone?: Timezone;

  /**
   * @generated from field: types.Address address = 5;
   */
  address?: Address;

  /**
   * @generated from field: types.Base base = 6;
   */
  base?: Base;

  /**
   * @generated from field: types.ID facility_group_id = 7;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 8;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message core.v1.Facility.
 * Use `create(FacilitySchema)` to create a new message.
 */
export const FacilitySchema: GenMessage<Facility> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 0);

/**
 * @generated from message core.v1.CreateFacilityRequest
 */
export type CreateFacilityRequest = Message<"core.v1.CreateFacilityRequest"> & {
  /**
   * @generated from field: core.v1.CreateFacilityInput input = 1;
   */
  input?: CreateFacilityInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message core.v1.CreateFacilityRequest.
 * Use `create(CreateFacilityRequestSchema)` to create a new message.
 */
export const CreateFacilityRequestSchema: GenMessage<CreateFacilityRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 1);

/**
 * @generated from message core.v1.CreateFacilityInput
 */
export type CreateFacilityInput = Message<"core.v1.CreateFacilityInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string facility_name = 2;
   */
  facilityName: string;

  /**
   * @generated from field: string facility_type = 3;
   */
  facilityType: string;

  /**
   * @generated from field: types.Timezone timezone = 4;
   */
  timezone?: Timezone;

  /**
   * @generated from field: types.Address address = 5;
   */
  address?: Address;

  /**
   * @generated from field: types.ID facility_group_id = 6;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 7;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message core.v1.CreateFacilityInput.
 * Use `create(CreateFacilityInputSchema)` to create a new message.
 */
export const CreateFacilityInputSchema: GenMessage<CreateFacilityInput> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 2);

/**
 * @generated from message core.v1.UpdateFacilityRequest
 */
export type UpdateFacilityRequest = Message<"core.v1.UpdateFacilityRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string facility_name = 2;
   */
  facilityName: string;

  /**
   * @generated from field: string facility_type = 3;
   */
  facilityType: string;

  /**
   * @generated from field: types.Timezone timezone = 4;
   */
  timezone?: Timezone;

  /**
   * @generated from field: types.Address address = 5;
   */
  address?: Address;

  /**
   * @generated from field: types.ID facility_group_id = 6;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 7;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message core.v1.UpdateFacilityRequest.
 * Use `create(UpdateFacilityRequestSchema)` to create a new message.
 */
export const UpdateFacilityRequestSchema: GenMessage<UpdateFacilityRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 3);

/**
 * @generated from message core.v1.GetFacilityRequest
 */
export type GetFacilityRequest = Message<"core.v1.GetFacilityRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.GetFacilityRequest.
 * Use `create(GetFacilityRequestSchema)` to create a new message.
 */
export const GetFacilityRequestSchema: GenMessage<GetFacilityRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 4);

/**
 * @generated from message core.v1.DeleteFacilityRequest
 */
export type DeleteFacilityRequest = Message<"core.v1.DeleteFacilityRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message core.v1.DeleteFacilityRequest.
 * Use `create(DeleteFacilityRequestSchema)` to create a new message.
 */
export const DeleteFacilityRequestSchema: GenMessage<DeleteFacilityRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 5);

/**
 * @generated from message core.v1.FacilityFilter
 */
export type FacilityFilter = Message<"core.v1.FacilityFilter"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: repeated string facility_types = 2;
   */
  facilityTypes: string[];

  /**
   * @generated from field: types.ID facility_group_id = 3;
   */
  facilityGroupId?: ID;

  /**
   * @generated from field: string search_term = 4;
   */
  searchTerm: string;

  /**
   * @generated from field: repeated core.v1.FacilitySortOption sorting = 5;
   */
  sorting: FacilitySortOption[];

  /**
   * @generated from field: int32 offset = 6;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 7;
   */
  limit: number;

  /**
   * @generated from field: double latitude = 8;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 9;
   */
  longitude: number;

  /**
   * @generated from field: double radius_in_meters = 10;
   */
  radiusInMeters: number;

  /**
   * @generated from field: repeated types.ID ids = 11;
   */
  ids: ID[];

  /**
   * @generated from field: repeated types.ID created_by = 12;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 13;
   */
  updatedBy: ID[];
};

/**
 * Describes the message core.v1.FacilityFilter.
 * Use `create(FacilityFilterSchema)` to create a new message.
 */
export const FacilityFilterSchema: GenMessage<FacilityFilter> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 6);

/**
 * @generated from message core.v1.ListFacilitiesRequest
 */
export type ListFacilitiesRequest = Message<"core.v1.ListFacilitiesRequest"> & {
  /**
   * @generated from field: core.v1.FacilityFilter filter = 1;
   */
  filter?: FacilityFilter;
};

/**
 * Describes the message core.v1.ListFacilitiesRequest.
 * Use `create(ListFacilitiesRequestSchema)` to create a new message.
 */
export const ListFacilitiesRequestSchema: GenMessage<ListFacilitiesRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 7);

/**
 * @generated from message core.v1.ListFacilitiesResponse
 */
export type ListFacilitiesResponse = Message<"core.v1.ListFacilitiesResponse"> & {
  /**
   * @generated from field: repeated core.v1.Facility facilities = 1;
   */
  facilities: Facility[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message core.v1.ListFacilitiesResponse.
 * Use `create(ListFacilitiesResponseSchema)` to create a new message.
 */
export const ListFacilitiesResponseSchema: GenMessage<ListFacilitiesResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 8);

/**
 * @generated from message core.v1.ListAllFacilitiesRequest
 */
export type ListAllFacilitiesRequest = Message<"core.v1.ListAllFacilitiesRequest"> & {
};

/**
 * Describes the message core.v1.ListAllFacilitiesRequest.
 * Use `create(ListAllFacilitiesRequestSchema)` to create a new message.
 */
export const ListAllFacilitiesRequestSchema: GenMessage<ListAllFacilitiesRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 9);

/**
 * @generated from message core.v1.ListAllFacilitiesResponse
 */
export type ListAllFacilitiesResponse = Message<"core.v1.ListAllFacilitiesResponse"> & {
  /**
   * @generated from field: repeated core.v1.Facility facilities = 1;
   */
  facilities: Facility[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message core.v1.ListAllFacilitiesResponse.
 * Use `create(ListAllFacilitiesResponseSchema)` to create a new message.
 */
export const ListAllFacilitiesResponseSchema: GenMessage<ListAllFacilitiesResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 10);

/**
 * @generated from message core.v1.GetFacilityResponse
 */
export type GetFacilityResponse = Message<"core.v1.GetFacilityResponse"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;
};

/**
 * Describes the message core.v1.GetFacilityResponse.
 * Use `create(GetFacilityResponseSchema)` to create a new message.
 */
export const GetFacilityResponseSchema: GenMessage<GetFacilityResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 11);

/**
 * @generated from message core.v1.CreateFacilityResponse
 */
export type CreateFacilityResponse = Message<"core.v1.CreateFacilityResponse"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;
};

/**
 * Describes the message core.v1.CreateFacilityResponse.
 * Use `create(CreateFacilityResponseSchema)` to create a new message.
 */
export const CreateFacilityResponseSchema: GenMessage<CreateFacilityResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 12);

/**
 * @generated from message core.v1.UpdateFacilityResponse
 */
export type UpdateFacilityResponse = Message<"core.v1.UpdateFacilityResponse"> & {
  /**
   * @generated from field: core.v1.Facility facility = 1;
   */
  facility?: Facility;
};

/**
 * Describes the message core.v1.UpdateFacilityResponse.
 * Use `create(UpdateFacilityResponseSchema)` to create a new message.
 */
export const UpdateFacilityResponseSchema: GenMessage<UpdateFacilityResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 13);

/**
 * @generated from message core.v1.GetFacilitiesByCustomAttributeRequest
 */
export type GetFacilitiesByCustomAttributeRequest = Message<"core.v1.GetFacilitiesByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated google.protobuf.Value attribute_values = 2;
   */
  attributeValues: Value[];
};

/**
 * Describes the message core.v1.GetFacilitiesByCustomAttributeRequest.
 * Use `create(GetFacilitiesByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetFacilitiesByCustomAttributeRequestSchema: GenMessage<GetFacilitiesByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 14);

/**
 * @generated from message core.v1.GetFacilitiesByCustomAttributeResponse
 */
export type GetFacilitiesByCustomAttributeResponse = Message<"core.v1.GetFacilitiesByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated core.v1.Facility facilities = 1;
   */
  facilities: Facility[];
};

/**
 * Describes the message core.v1.GetFacilitiesByCustomAttributeResponse.
 * Use `create(GetFacilitiesByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetFacilitiesByCustomAttributeResponseSchema: GenMessage<GetFacilitiesByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 15);

/**
 * Request message for checking search permissions on facilities
 *
 * @generated from message core.v1.CheckFacilitySearchPermissionsRequest
 */
export type CheckFacilitySearchPermissionsRequest = Message<"core.v1.CheckFacilitySearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];
};

/**
 * Describes the message core.v1.CheckFacilitySearchPermissionsRequest.
 * Use `create(CheckFacilitySearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckFacilitySearchPermissionsRequestSchema: GenMessage<CheckFacilitySearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 16);

/**
 * Response message for the CheckSearchPermissions RPC
 *
 * @generated from message core.v1.CheckFacilitySearchPermissionsResponse
 */
export type CheckFacilitySearchPermissionsResponse = Message<"core.v1.CheckFacilitySearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated types.ID permitted_ids = 1;
   */
  permittedIds: ID[];
};

/**
 * Describes the message core.v1.CheckFacilitySearchPermissionsResponse.
 * Use `create(CheckFacilitySearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckFacilitySearchPermissionsResponseSchema: GenMessage<CheckFacilitySearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_core_v1_facility, 17);

/**
 * Facility filter options
 *
 * @generated from enum core.v1.FacilitySortOption
 */
export enum FacilitySortOption {
  /**
   * @generated from enum value: FACILITY_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_NAME_ASC = 1;
   */
  NAME_ASC = 1,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_NAME_DESC = 2;
   */
  NAME_DESC = 2,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_TYPE_ASC = 3;
   */
  TYPE_ASC = 3,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_TYPE_DESC = 4;
   */
  TYPE_DESC = 4,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: FACILITY_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum core.v1.FacilitySortOption.
 */
export const FacilitySortOptionSchema: GenEnum<FacilitySortOption> = /*@__PURE__*/
  enumDesc(file_core_v1_facility, 0);

/**
 * Facility query service definition
 *
 * @generated from service core.v1.FacilityQueriesService
 */
export const FacilityQueriesService: GenService<{
  /**
   * @generated from rpc core.v1.FacilityQueriesService.GetFacility
   */
  getFacility: {
    methodKind: "unary";
    input: typeof GetFacilityRequestSchema;
    output: typeof GetFacilityResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityQueriesService.ListFacilities
   */
  listFacilities: {
    methodKind: "unary";
    input: typeof ListFacilitiesRequestSchema;
    output: typeof ListFacilitiesResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityQueriesService.ListAllFacilities
   */
  listAllFacilities: {
    methodKind: "unary";
    input: typeof ListAllFacilitiesRequestSchema;
    output: typeof ListAllFacilitiesResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityQueriesService.GetFacilitiesByCustomAttribute
   */
  getFacilitiesByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetFacilitiesByCustomAttributeRequestSchema;
    output: typeof GetFacilitiesByCustomAttributeResponseSchema;
  },
  /**
   * CheckSearchPermissions checks which of the provided facility IDs the user has permission to access
   *
   * @generated from rpc core.v1.FacilityQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckFacilitySearchPermissionsRequestSchema;
    output: typeof CheckFacilitySearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_facility, 0);

/**
 * Facility command service definition
 *
 * @generated from service core.v1.FacilityCommandsService
 */
export const FacilityCommandsService: GenService<{
  /**
   * @generated from rpc core.v1.FacilityCommandsService.CreateFacility
   */
  createFacility: {
    methodKind: "unary";
    input: typeof CreateFacilityRequestSchema;
    output: typeof CreateFacilityResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityCommandsService.UpdateFacility
   */
  updateFacility: {
    methodKind: "unary";
    input: typeof UpdateFacilityRequestSchema;
    output: typeof UpdateFacilityResponseSchema;
  },
  /**
   * @generated from rpc core.v1.FacilityCommandsService.DeleteFacility
   */
  deleteFacility: {
    methodKind: "unary";
    input: typeof DeleteFacilityRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_core_v1_facility, 1);

